import styled from 'styled-components';

export const Container = styled.div`
  /* display: flex; */
  justify-content: space-between;
  align-items: flex-start;
  @media (max-width: 520px) {
    flex-direction: column;
  }

  max-width: auto;
  max-height: 100%;
  margin: auto;

  flex-grow: 1;
`;
